/**
 * @public
 */
enum StatusEnum {
    Settled = 'Settled',
    Requesting = 'Requesting',
    Failed = 'Failed',
}

export default StatusEnum
